import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import { Loader } from "components/Loader"
import { ConnexionError } from "components/ConnexionError"
import React from "react"

interface DataStateHandlerProps {
    isLoading: boolean
    apiSuccess: boolean | null
    noResultFilter: boolean
    children: React.ReactNode
}

const UnexpectedResult = (children: React.ReactNode) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>{children}</Box>
    )
}

export const DataStateHandler = ({
    isLoading,
    apiSuccess,
    noResultFilter,
    children,
}: DataStateHandlerProps) => {
    if (isLoading && apiSuccess === null) {
        return UnexpectedResult(<Loader />)
    }

    if (!apiSuccess) {
        return UnexpectedResult(<ConnexionError />)
    }

    if (noResultFilter) {
        return UnexpectedResult(
            <Typography sx={{ color: "grey.600" }}>Aucun résultat</Typography>
        )
    }

    return <>{children}</>
}
